import { Drawer } from '@templates/index';
import { useUiStore } from '@store/index';
import { SynthPanel } from './SynthPanel';

/**
 * Right-slide drawer dedicated to the synthesizer (timbre / ADSR /
 * effects).
 */
export function SynthDrawer() {
  const open = useUiStore((s) => s.synthOpen);
  const setOpen = useUiStore((s) => s.setSynthOpen);
  const toggle = useUiStore((s) => s.toggleSynth);

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      onToggle={toggle}
      title="Synth"
      width="min(420px, 94vw)"
      backdrop="transparent"
      shortcut="s"
      hint={
        <>
          <kbd>S</kbd> toggle · <kbd>Esc</kbd> close
        </>
      }
    >
      <SynthPanel />
    </Drawer>
  );
}
